import { callApi } from "../../callApi"

type ApiParams = {
  partnerUuid: string
  fleetUuid?: string
  endpointType: string
}

const buildPath = ({ partnerUuid, fleetUuid, endpointType }: ApiParams): string => {
  if (fleetUuid) {
    return `/partner/${partnerUuid}/fleets/${fleetUuid}/statistics/${endpointType}`
  }
  return `/partner/${partnerUuid}/statistics/${endpointType}`
}

export type GET_STATISTICS_COUNT_RESPONSE = {
  count: number
}

export type GET_DISTANCE_RESPONSE = {
  avg_distance: number
  avg_distance_unit: string
  total_distance: number
  total_distance_unit: string
}

export type GET_CO2_RESPONSE = {
  avg_co2: number
  avg_co2_unit: string
  total_co2: number
  total_co2_unit: string
}

export type GET_TRIP_RESPONSE = {
  avg_trips: number
  total_trips: number
}

export type GET_SPEED_RESPONSE = {
  avg_speed: number
  avg_speed_unit: string
  total_speed: number
  total_speed_unit: string
}

export type GET_PARTNER_STATISTICS_PARAMS = {
  partner_id: string
  page: number
  per_page: number
  search_string?: string
  sort_by?: string
  sort_desc?: boolean
  months?: number
  fleetUuid?: string
}

// new fleet statistics

export const getDistance = async (partnerUuid: string, fleetUuid: string) =>
  callApi<null, GET_DISTANCE_RESPONSE>({
    method: "GET",
    path: buildPath({ partnerUuid, fleetUuid, endpointType: "distance" }),
  })

export const getCo2 = async (partnerUuid: string, fleetUuid: string) =>
  callApi<null, GET_CO2_RESPONSE>({
    method: "GET",
    path: buildPath({ partnerUuid, fleetUuid, endpointType: "co2" }),
  })

export const getTrips = async (partnerUuid: string, fleetUuid: string) =>
  callApi<null, GET_TRIP_RESPONSE>({
    method: "GET",
    path: buildPath({ partnerUuid, fleetUuid, endpointType: "trips" }),
  })

export const getSpeed = async (partnerUuid: string, fleetUuid: string) =>
  callApi<null, GET_SPEED_RESPONSE>({
    method: "GET",
    path: buildPath({ partnerUuid, fleetUuid, endpointType: "speed" }),
  })
